@use "~theme/breakpoints";
@use "~theme/typography";
// Loader overlay for full-page spinner
.loader_overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(255,255,255,0.85);
    z-index: 9999;
    display: flex;
    align-items: center;
    justify-content: center;
}

.loader {
    border: 8px solid var(--loader-gray);
    border-top: 8px solid var(--loader-blue);
    border-radius: 50%;
    width: 60px;
    height: 60px;
    animation: spin 1s linear infinite;
}

@keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
}
// Close X button for modal
.idleModalCloseButton {
    position: absolute;
    top: -36px;      // pushes it above the white card
    right: 0;        // align to modal right edge
    display: inline-flex;
    align-items: center;
    gap: 10px;

    background: transparent;
    border: none;
    padding: 6px 8px;
    margin: 0;

    color: var(--white);     // sits on the dark overlay
    cursor: pointer;
    z-index: 2;
    line-height: 1;

    // remove the “button-ish” look
    box-shadow: none;
    border-radius: 0;
}

.idleModalCloseButton:hover,
.idleModalCloseButton:focus-visible {
    opacity: 0.9;
    outline: none;
}

.idleModalCloseButton:focus-visible {
    // accessible focus ring on dark overlay
    outline: 2px solid var(--white);
    outline-offset: 4px;
}

.idleModalCloseLabel {
    font-size: 16px;
    font-weight: 600;
}

.idleModalCloseIcon {
    font-size: 26px;
    font-weight: 400;
    transform: translateY(-1px);
}

// Overlay for idle warning modal that blocks all content
.idleModalOverlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0,0,0,0.7);
    z-index: 9999;
    display: flex;
    align-items: center;
    justify-content: center;
    pointer-events: auto;
}

.idleModalContentWrapper {
    position: relative; // anchor for the floating close control
    background: var(--white);
    border-radius: 8px;
    box-shadow: 0 2px 16px rgba(0,0,0,0.2);
    padding: 32px;
    min-width: 320px;
    max-width: 90vw;
    text-align: center;
    pointer-events: auto;
}

.w100 {
    width: 100%
}

.flex {
    display: -webkit-box;
    display: flex;
}

.fcolumn {
    -webkit-box-direction: normal;
}

.grow1 {
    -webkit-box-flex: 1;
    flex-grow: 1
}

.hideContainer {
    display: none;
}

.showContainer {
    display: block;
    position: relative;
}

.cardContainer {
    border: 1px solid var(--interface-200);
    border-radius: .25rem;
    padding: 32px;
    max-width: 37.5rem;
    width: 95%;
    margin: 1.25rem auto;
    background-color: white;
    position: relative;
}

.patientList a {
    text-decoration: none
}

.header {
}

.heading,.info {
    font-family: proxima-nova, sans-serif;
    font-weight: 400;
    text-align: left
}
.heading {
    color: var(--Brand-Color---brand-color-deep-charcoal, var(--black));
    /* Button mobile */
    font-family: proxima-nova, sans-serif;
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: 140%; /* 25.2px */
    letter-spacing: 0.18px;
    text-transform: uppercase;
}

.info {
    color: var(--Brand-Color---brand-color-deep-charcoal, var(--black));
    font-family: proxima-nova, sans-serif;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 140%;
}

.ErrorMessage {
    background-color: var(--interface-050);
    border: 1px solid var(--interface-200);
    border-radius: .5rem;
    min-height: 22.625rem;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    flex-direction: column;
    row-gap: 1rem;
    padding: .9375rem
}

.ErrorMessage__Title {
    font-family: proxima-nova, sans-serif;
    font-size: 1.125rem;
    font-weight: 600;
    line-height: 1.5625rem;
    letter-spacing: -.01em;
    text-align: center;
    color: var(--black);
    margin: 0
}

.ErrorMessage__Text {
    font-family: proxima-nova, sans-serif;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.375rem;
    letter-spacing: 0;
    text-align: center;
    color: var(--black);
    margin: 0;
    max-width: 20.875rem
}

.ErrorMessage__Text a {
    color: var(--link-blue)
}

.NoPatients {
    margin: 2rem 0
}

.NoPatients,.NoPatients__Content {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    row-gap: 2rem;
    position: relative
}

.NoPatients__Content {
    z-index: 1;
    width: 100%
}

.NoPatients__Background {
    position: absolute;
    bottom: -2rem;
    left: 0;
    width: 100%;
    height: 302px;
    background: url('data:image/svg+xml;utf8,<svg width="1920" height="302" viewBox="0 0 1920 302" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M408.976 162.299L0 0V302H1920V63.6871L1755.81 162.299L1514.51 63.6871L1138.37 162.299L745.81 63.6871L408.976 162.299Z" fill="url(%23paint0_linear_9839_56781)"/><defs><linearGradient id="paint0_linear_9839_56781" x1="960" y1="0" x2="960" y2="302" gradientUnits="userSpaceOnUse"><stop stop-color="white"/><stop offset="0.511458" stop-color="%23EFF7FC"/><stop offset="1" stop-color="%23E0F0F9"/></linearGradient></defs></svg>') no-repeat bottom;
    background-size: cover;
    z-index: 0
}

.NoPatients__Divider {
    display: block;
    height: 1px;
    width: 100%;
    background-color: var(--interface-200)
}

.NoPatients__Heading {
    font-family: proxima-nova, sans-serif;
    font-size: 2rem;
    font-weight: 600;
    line-height: 2.8rem;
    letter-spacing: -.015em;
    text-align: center;
    color: var(--blue-01);
    max-width: 39.5rem;
    margin: 0
}

.NoPatients__Paragraph {
    font-family: proxima-nova, sans-serif;
    font-size: 1.25rem;
    font-weight: 400;
    line-height: 1.75rem;
    text-align: center
}

.NoPatients__Cards {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    -moz-column-gap: 2rem;
    column-gap: 2rem;
    row-gap: 2rem;
    margin-bottom: 12.5rem
}

.NoPatients__Card {
    width: 18.625rem;
    gap: .625rem;
    border-radius: .5rem;
    border: 1px solid var(--interface-200);
    padding: 1rem;
    display: flex;
    flex-direction: column;
    -moz-column-gap: .5rem;
    column-gap: .5rem;
    background-color: var(--white)
}

.NoPatients__CardHeading {
    font-family: proxima-nova, sans-serif;
    font-size: 1rem;
    font-weight: 600;
    line-height: 1.4rem;
    letter-spacing: -.01em;
    text-align: left;
    margin: 0
}

.NoPatients__CardParagraph {
    font-family: proxima-nova, sans-serif;
    font-size: 14px;
    font-weight: 400;
    line-height: 19.6px;
    text-align: left
}

.NoPatients__Link {
    font-family: proxima-nova, sans-serif;
    font-size: 16px;
    font-weight: 500;
    line-height: 21.86px;
    text-align: left;
    color: var(--blue-01);
    text-decoration: none
}

.NoPatients__Link span {
    text-decoration: underline
}

.PatientSelector {
}

.loading {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 18.75rem
}

.confirmDataLink {
    color: white;
    margin-top:1rem;
    position: relative;
    left: -56px;
    width: 90px;
    height: 40px;
    opacity: 1;
    gap: 10px;
    border-radius: 4px;
    padding: 0px;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;
    @include breakpoints.desktop {
        margin-top: 0px; 
        left: 0px;
    }

    span {
        color: var(--base-color-base-color-white-ffffff, var(--white));

        /* Button mobile */
        font-family: proxima-nova, sans-serif;
        font-size: 18px;
        font-style: normal;
        font-weight: 600;
        line-height: 140%; /* 25.2px */
        letter-spacing: 0.18px;
        text-transform: uppercase;
        margin-top: -5px;
        @include breakpoints.desktop {
            font-weight: 400;
        }
    }
}

.confirmDataLink:focus-visible {
    outline-offset: 7px;
    outline-color: var(--blue-01);
    outline-style: solid
}

.card {
    display: block;
    margin-bottom: 1rem;
    border-width: 1px, 1px, 1px, 0px;
    border-style: solid;
    border-color: var(--Interface-Colors---interface-color-200, var(--interface-200));
    opacity: 1;
    gap: 16px;
    padding: 16px;
    border-top-width: 1px;
    border-right-width: 1px;
    border-bottom-width: 1px;
    border-left: 4px solid var(--Primary-Color---brand-color-light-blue, var(--highlight-blue-02));
}

.divider {
    border: 1px solid var(--Interface-Colors---interface-color-50, var(--interface-050));
    margin: 16px 0px;
}

.accHeader {
    color: var(--Brand-Color---brand-color-deep-charcoal, var(--black));
    font-family: proxima-nova, sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 140%;
    letter-spacing: 0.14px;
    text-transform: uppercase;
}

.buttons {
    display: flex;
    flex-direction: column;    
    @include breakpoints.desktop {
        flex-direction: row;
    }
}

.row {
    display: flex;
    margin-bottom: 10px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    @include breakpoints.desktop {
        justify-content: space-between;
    }
}

.field {
    margin: 0 20px 0 0;
    color: var(--Brand-Color-Deep-Charcoal, var(--black));
    /* Body/--font-size-body-medium: 16px */
    font-family: proxima-nova, sans-serif;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 140%; /* 22.4px */
    span {
        color: var(--Brand-Color-Deep-Charcoal, var(--black));
        font-family: proxima-nova, sans-serif;
        font-size: 12px;
        font-style: normal;
        font-weight: 600;
        line-height: 140%;
        letter-spacing: -0.12px;
    }
}


.icon {
    display: flex;
    justify-content: center;
    align-items:  flex-start;
    @include breakpoints.desktop {
        align-items: center;
    }
}

.PatientList a {
    text-decoration: none
}

.patientText {
    color: var(--Brand-Color-Deep-Charcoal, var(--black));
    text-align: center;
    font-family: proxima-nova, sans-serif;
    font-size: 12px;
    font-style: normal;
    font-weight: 600;
    line-height: 140%; /* 16.8px */
    letter-spacing: -0.12px;
}

.item {
    display: flex;
    justify-content: space-between;
    -moz-column-gap: .5rem;
    column-gap: .5rem;
}

.patientName {
    color: var(--Brand-Color-Deep-Charcoal, var(--black));
    font-family: proxima-nova, sans-serif;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 140%;
    text-transform: uppercase;
    word-break: break-word;
    overflow-wrap: anywhere;
    @include breakpoints.desktop {
        font-weight: 400;
    }
}

.date {
    color: var(--Brand-Color-Deep-Charcoal, var(--black));
    font-family: proxima-nova, sans-serif;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 140%; /* 22.4px */
    padding: 0px;
    margin: 0px;
    word-break: break-word;
    overflow-wrap: anywhere;
}

.nameWrapper {
    min-width: 0;
    margin-right: auto;
    max-width: 100%;
}

.info {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    
    flex-direction:column;
    align-items: flex-start;
    row-gap: .625rem;
    @include breakpoints.desktop {
        flex-direction:row;
        -moz-column-gap: 3.25rem;
        column-gap: 3.25rem;
        min-width: 0;
    }
}

.btnWrapper {
    width: 3.125rem;
    display: flex;
    justify-content: center;
    align-items: center
}

span.holderTag {
    color: var(--link-blue);
    background-color: var(--info-blue-02);
    display: inline-block;
    padding: .25rem .625rem;
    border-radius: 1.875rem;
    margin: 0 .625rem;
    font-weight: 400
}

.srOnly {
    border: 0;
    clip: rect(0 0 0 0);
    -webkit-clip-path: inset(50%);
    clip-path: inset(50%);
    height: 1;
    margin: 0 -1px -1px 0;
    overflow: hidden;
    padding: 0;
    position: absolute;
    width: 1
}


.bannerContainer {
    background-color: var(--white);
    padding: 16px;
    max-width: 600px;
    margin-bottom: 20px !important;
    border-radius: 4px;
    margin: 1.5rem auto 0;
    border: 1.5px solid var(--interface-200);
    width: 95%;
    @include breakpoints.desktop {
        height: 120px;
    }
}

.bannerHeading {
    font-family: proxima-nova, sans-serif;
    font-weight: 600;
    font-style: Demi Bold;
    font-size: 16px;
    leading-trim: NONE;
    line-height: 140%;
    letter-spacing: -1%;
    vertical-align: middle;
    padding: 0px;
    margin: 0px;
}

.bannerText {
    font-family: proxima-nova, sans-serif;
    font-weight: 400;
    font-style: Regular;
    font-size: 14px;
    leading-trim: NONE;
    line-height: 140%;
    letter-spacing: 0%;
    vertical-align: middle;
}

.bannerLink {
    color: var(--link-blue);
    text-decoration: underline
}

.inlineSpinnerWrapper {
    position: absolute;
    inset: 0;
    z-index: 10;
    pointer-events: none;
    display: flex;
    align-items: flex-end;
    justify-content: center;
    padding-bottom: 12px;
}

.inlineSpinner {
    width: 28px;
    height: 28px;
    border: 3px solid var(--gray-10);
    border-top: 3px solid var(--loader-blue);
    border-radius: 50%;
    animation: spin 1s linear infinite;
}



.ConfirmDataForm {
    font-family: proxima-nova, sans-serif;
    color: var(--black)
}

.phoneNumberfield {
    display: block
}

.ConfirmDataForm__heading {
    font-size: 18px;
    font-weight: 600;
    margin: 0 0 1rem;
    text-transform: uppercase
}


.paragraph {
    font-size: 1rem;
    line-height: 1.4rem;
    margin: 0 0 1rem;
    color: var(--Brand-Color---brand-color-deep-charcoal, var(--black));
    font-family: proxima-nova, sans-serif;   
    font-style: normal;
    @include breakpoints.desktop {
        font-size: 16px;        
        font-weight: 400;
        line-height: 140%; /* 22.4px */
    }
}

.label {
    color: var(--Brand-Color-Deep-Charcoal, var(--black));
    font-family: proxima-nova, sans-serif;
    font-size: 12px;
    font-style: normal;
    font-weight: 600;
    line-height: 140%;
    letter-spacing: -0.12px;
}

.labelForm {
    color: var(--Primary-Color---primary-color-navy-interface, var(--blue-01));
    font-family: proxima-nova, sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 140%; /* 19.6px */
}
.infoForm {
    color: var(--Interface-Colors---interface-color-900-charcoal, var(--interface-900));
    font-family: proxima-nova, sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 140%; /* 19.6px */
}
.errorGlobal, .errorGlobalQuest {
   color: var(--Additional-Color---additional-interface-color-300-magenta, var(--magenta));

    /* Body/--font-size-body-medium: 16px */
    font-family: proxima-nova, sans-serif;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 140%; /* 22.4px */
    margin-top: 16px;
    a {
        color: var(--link-blue);
    }
}

.errorGlobal a {
    color: var(--magenta)
}

.info {
    border-radius: 4px
}

.info p {
    font-size: 16px;
    font-weight: 400;
    font-family: proxima-nova, sans-serif;
    font-synthesis: 1.4rem;
    margin: 0;
    line-height: 19.6px;
    color: var(--interface-900)
}

.Form {
    display: flex;
    flex-direction: column;
    row-gap: 1rem
}

.submit {
    display: flex;
    height: 48px;
    justify-content: center;
    align-items: center;
    gap: 10px;
    flex: 1 0 0;
    margin-top: 16px;
    border-radius: 4px;
    background: var(--Primary-Color---primary-color-navy-interface, var(--blue-01));
    color: var(--base-color-base-color-white-ffffff, var(--white));
    font-family: proxima-nova, sans-serif;
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: 140%;
    letter-spacing: 0.18px;
    text-transform: uppercase;
    width: 100%;
}

.submit:focus-visible {
    outline-color: var(--blue-01);
}

.InputWrapper input {
    display: block;
    color: var(--black);
    font-size: 1rem;
    line-height: 1.4rem;
    font-family: proxima-nova, sans-serif;
    width: 100%;
    height: 2.875rem;
    padding: .75rem 1rem;
    box-sizing: border-box;
    border-radius: 4px;
    background-color: var(--interface-050);
    border: 1px solid var(--interface-200)
}

.InputWrapperError input {
    border: 1px solid var(--magenta)
}

.InputErroMessage {
    color: var(--error-red);
    position: absolute;
    font-size: 11px;
    margin-top: 0
}

.back {
    font-weight: 400;
    font-size: .875rem;
    text-align: center;
    text-decoration: none;
    display: flex;
    justify-content: center;
    align-items: center;
    -moz-column-gap: .3125rem;
    column-gap: .3125rem;
    width: -webkit-fit-content;
    width: -moz-fit-content;
    width: fit-content;
    color: var(--blue-00);
    margin-bottom: 1.25rem;
    cursor: pointer;
    span {
        color: var(--Primary-Color---primary-color-navy, var(--blue-00));
        text-align: center;
        font-family: proxima-nova, sans-serif;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 140%;
    }
}

.checkboxLabel {
    display: flex;
    align-items: center;
    font-family: proxima-nova, sans-serif;
    font-size: 14px;
    font-weight: 400;
    line-height: 19.6px;
    text-align: left
}

.checkbox {
    border: 1px solid var(--interface-200);
    border-radius: 2px;
    margin-right: 8px
}

.checkbox[type=checkbox] {
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    width: 20px;
    height: 20px;
    border: 2px solid var(--gray-07);
    border-radius: 3px;
    position: relative;
    cursor: pointer;
    outline: none
}

.checkbox[type=checkbox]:checked:before {
    content: "";
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    width: 18px;
    height: 18px;
    background-color: var(--blue-01);
    border-radius: 3px
}

.checkbox[type=checkbox]:before {
    content: "";
    display: block;
    width: 100%;
    height: 100%;
    background-color: var(--white);
    border-radius: 3px
}

.checkbox[type=checkbox]:checked:after {
    content: "";
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%) rotate(-45deg);
    font-size: 14px;
    height: 5px;
    width: 10px;
    border-left: 2px solid var(--white);
    border-bottom: 2px solid var(--white)
}


.patientdatacontainer {
    display: flex;
    flex-direction: column;
    gap: 20px;
    border-top: 1px solid var(--gray-07);
    border-bottom: 1px solid var(--gray-07);
    margin-bottom: 14px;
}

.patientdatarow {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 16px;
    margin-top: 16px;
    gap: 20px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    @include breakpoints.desktop {
        flex-wrap: nowrap;
    }
}

.patientdatafield {
    flex: 1;
    min-width: 45%;
    display: flexs;
    width: 105px;
    flex-direction: column;
    align-items: flex-start;
    @include breakpoints.desktop {
        flex: 1;
        min-width: 20%;
    }
}

.textInput {
    display: block;
    padding-bottom: 16px;
    input {
        display: flex;
        padding: 12px 16px;
        align-items: center;
        align-self: stretch;
        border-radius: 4px;
        border: 1px solid var(--Interface-Colors---interface-color-200, var(--interface-200));
        background: var(--Interface-Colors---interface-color-50, var(--interface-050));
        box-shadow: none;
    }

    .errorClassName {
        border: 1px solid var(--Additional-Color---additional-interface-color-300-magenta, var(--magenta));
    }

    img {
        display: none;
    }

    p {
        display: none;
    }
}

.textInputShow {
    display: block;
    padding-bottom: 0px;
    input {
        display: flex;
        padding: 12px 16px;
        align-items: center;
        align-self: stretch;
        border-radius: 4px;
        border: 1px solid var(--Interface-Colors---interface-color-200, var(--interface-200));
        background: var(--Interface-Colors---interface-color-50, var(--interface-050));
        box-shadow: none;
    }

    .errorClassName {
        border: 1px solid var(--Additional-Color---additional-interface-color-300-magenta, var(--magenta));
    }

    img {
        display: none;
    }
}

.errCard {
    margin-bottom: 0px;
}

.errContainer {
    display: flex;
    padding: 8px;
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
    border: 1px solid var(--Additional-Color---additional-interface-color-300-magenta, var(--magenta));
    background: var(--Cherry-Light, var(--cherry-light));

    .errRow {
        display: flex;
        align-items: center;
        gap: 8px;
        align-self: stretch;
    }

    .errText {
        color: var(--Brand-Color-Deep-Charcoal, var(--black));
        font-family: proxima-nova, sans-serif;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 140%;
        letter-spacing: -0.24px;

        a {
            color: var(--Additional-Color---additional-interface-color-focus-2, var(--link-blue));
            font-family: proxima-nova, sans-serif;
            font-size: 16px;
            font-style: normal;
            font-weight: 400;
            line-height: 140%;
            letter-spacing: -0.24px;
            text-decoration-line: underline;
            text-decoration-style: solid;
            text-decoration-skip-ink: none;
            text-decoration-thickness: auto;
            text-underline-offset: auto;
            text-underline-position: from-font;

        }
    }
}


.qContainer {
    display: flex;
    align-items: center;
    gap: 16px;
    align-self: stretch;
}

.qNumber {
    display: flex;
    width: 26px;
    padding: 2px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 10px;
    border-radius: 800px;
    background: var(--Interface-Colors---interface-color-100-light, var(--info-blue-02));
}

.qLabel {
    color: var(--Interface-Colors---interface-color-900, var(--blue-00));
    font-family: proxima-nova, sans-serif;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 140%;
    letter-spacing: -0.16px;
    flex: 1 0 0;
}

.radioButton {
    display: flex;
    align-items: center;
    gap: var(--Space-2, 8px);
    align-self: stretch;
    color: var(--Brand-Color-Deep-Charcoal, var(--black));
    font-family: proxima-nova, sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 140%;
    padding: 16px 0px;
    width: 100%;
}

.qrLeft {
    display: flex;
    align-items: center;
    gap: var(--Space-2, 8px);
    align-self: stretch;
}

.buttonGroup {
    display: block;
}

.noPatientContainer, .noPatientContent {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    row-gap: 2rem;
    position: relative;
    background-color: white;
}

.noPatientContainer {
    padding-top: 50px;
}

.noPatientContent {
    z-index: 1;
    width: 100%;
}

.npHeading {
    
    font-size: 2rem;
    font-weight: 600;
    line-height: 2.8rem;
    letter-spacing: -.015em;
    text-align: center;
    color: var(--blue-01);
    max-width: 39.5rem;
    margin: 0;
}

.npDivider {
    display: block;
    height: 1px;
    width: 100%;
    background-color: var(--interface-200);
}

.npParagraph {
    
    font-size: 1.25rem;
    font-weight: 400;
    line-height: 1.75rem;
    text-align: center;
}

.npCards {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    -moz-column-gap: 2rem;
    column-gap: 2rem;
    row-gap: 2rem;
    margin-bottom: 12.5rem;
}

.npCard {
    width: 18.625rem;
    gap: .625rem;
    border-radius: .5rem;
    border: 1px solid var(--interface-200);
    padding: 1rem;
    display: flex;
    flex-direction: column;
    -moz-column-gap: .5rem;
    column-gap: .5rem;
    background-color: var(--white);
}

.npCardHeading {    
    font-size: 1rem;
    font-weight: 600;
    line-height: 1.4rem;
    letter-spacing: -.01em;
    text-align: left;
    margin: 0;
}
